module.exports = __webpack_public_path__ + "54f5276031561f05f721eb4e48d68b16.jpg";